import { render, staticRenderFns } from "./ModalCreateCollection.vue?vue&type=template&id=56292bca&"
import script from "./ModalCreateCollection.vue?vue&type=script&lang=js&"
export * from "./ModalCreateCollection.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreateCollection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports